import type { ProjectNode } from '@/shared/types/projectData';
import {
  isDocumentDisplayRecord,
  isInternalOnlyDocumentRecord,
  isMeetingRecord,
} from '@/shared/utils/documentRecordClassification';

export const isGanttDocumentRecord = (node: ProjectNode): boolean => isDocumentDisplayRecord(node);

export const isGanttMeetingRecord = (node: ProjectNode): boolean => isMeetingRecord(node);

export const isInternalOnlyGanttDocumentRecord = (node: ProjectNode): boolean =>
  isInternalOnlyDocumentRecord(node);
